import React from "react"

export default function PreferencesForm({
  trial,
  today,
  defaultEnd,
  preferences,
  onChange,
  onSubmit,
}) {
  /* helper for radio groups */
  const handleRadio = key => val => () =>
    onChange(key, preferences[key] === val ? "" : val)

  return (
    <div className="preferences-page-container">
      <h2 className="page-title">What Is Your Perfect Weather?</h2>

      <form
        className="preferences-form"
        onSubmit={e => {
          e.preventDefault()
          onSubmit()
        }}
      >
        {/* Temperature */}
        <fieldset className="preference-group">
          <legend>Temperature</legend>
          <label>
            <input
              type="radio"
              name="temperature"
              value="cool"
              checked={preferences.temperature === "cool"}
              onChange={handleRadio("temperature")("cool")}
            />
            Cool (65‑69 °F)
          </label>
          <label>
            <input
              type="radio"
              name="temperature"
              value="warm"
              checked={preferences.temperature === "warm"}
              onChange={handleRadio("temperature")("warm")}
            />
            Warm (70‑75 °F)
          </label>
          <label>
            <input
              type="radio"
              name="temperature"
              value="hot"
              checked={preferences.temperature === "hot"}
              onChange={handleRadio("temperature")("hot")}
            />
            Hot (76‑85 °F)
          </label>
        </fieldset>

        {/* Humidity */}
        <fieldset className="preference-group">
          <legend>Humidity</legend>
          <label>
            <input
              type="radio"
              name="humidity"
              value="humid"
              checked={preferences.humidity === "humid"}
              onChange={handleRadio("humidity")("humid")}
            />
            Humid
          </label>
          <label>
            <input
              type="radio"
              name="humidity"
              value="dry"
              checked={preferences.humidity === "dry"}
              onChange={handleRadio("humidity")("dry")}
            />
            Dry
          </label>
        </fieldset>

        {/* Sun / Clouds */}
        <fieldset className="preference-group">
          <legend>Sun / Clouds</legend>
          <label>
            <input
              type="radio"
              name="sunClouds"
              value="clear"
              checked={preferences.sunClouds === "clear"}
              onChange={handleRadio("sunClouds")("clear")}
            />
            Clear Skies <small>(bright & sunny)</small>
          </label>
          <label>
            <input
              type="radio"
              name="sunClouds"
              value="romanticClouds"
              checked={preferences.sunClouds === "romanticClouds"}
              onChange={handleRadio("sunClouds")("romanticClouds")}
            />
            Romantic Clouds <small>(soft overcast)</small>
          </label>
        </fieldset>

        {/* Sunset cutoff */}
        <fieldset className="preference-group">
          <legend>Sunset (No earlier than…)</legend>
          <select
            value={preferences.sunset}
            onChange={e => onChange("sunset", e.target.value)}
          >
            <option value="">Select a time</option>
            <option value="6:00 PM">6:00 PM</option>
            <option value="6:30 PM">6:30 PM</option>
            <option value="7:00 PM">7:00 PM</option>
            <option value="7:30 PM">7:30 PM</option>
            <option value="8:00 PM">8:00 PM</option>
          </select>
        </fieldset>

        {/* Wind */}
        <fieldset className="preference-group">
          <legend>Wind</legend>
          <label>
            <input
              type="radio"
              name="wind"
              value="calm"
              checked={preferences.wind === "calm"}
              onChange={handleRadio("wind")("calm")}
            />
            Calm
          </label>
          <label>
            <input
              type="radio"
              name="wind"
              value="breeze"
              checked={preferences.wind === "breeze"}
              onChange={handleRadio("wind")("breeze")}
            />
            Light Breeze
          </label>
        </fieldset>

        {/* Light precipitation */}
        <fieldset className="preference-group">
          <legend>Light Precipitation</legend>
          <p className="helper-text">
            Would you like a gentle hint of rain to add romance?
          </p>
          <label>
            <input
              type="radio"
              name="precipitation"
              value="yes"
              checked={preferences.precipitation === "yes"}
              onChange={handleRadio("precipitation")("yes")}
            />
            Yes, a light drizzle
          </label>
          <label>
            <input
              type="radio"
              name="precipitation"
              value="no"
              checked={preferences.precipitation === "no"}
              onChange={handleRadio("precipitation")("no")}
            />
            No, keep it dry
          </label>
        </fieldset>

        {/* Date range */}
        <fieldset className="preference-group">
          <legend>Date Range</legend>
          <label>
            Start&nbsp;Date&nbsp;
            <input
              type="date"
              value={preferences.startDate}
              min={today}
              max={trial ? defaultEnd : "2025-10-31"}
              onChange={e => onChange("startDate", e.target.value)}
            />
          </label>
          <label>
            End&nbsp;Date&nbsp;
            <input
              type="date"
              value={preferences.endDate}
              min={preferences.startDate}
              max={trial ? defaultEnd : "2025-12-31"}
              onChange={e => onChange("endDate", e.target.value)}
            />
          </label>
        </fieldset>
      </form>

      <div className="navigation-buttons-container preferences-footer">
        <button className="btn btn-primary" onClick={onSubmit}>
          See Dates
        </button>
      </div>
    </div>
  )
}
